export default "__VITE_ASSET__258c04b9__"